import MapDataStream from '../MapDataStream'
import { Observable } from 'rxjs';

export default class RasterTileDataStream extends MapDataStream {
    constructor(id, tilesUrls, tileSize, minZoom, maxZoom, scheme) {
        super(id);

        this.tilesUrls = tilesUrls;
        this.tileSize = tileSize;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        this.scheme = scheme;
    }

    observe() {
        const observable = new Observable((subscriber) => {
            this.subscriber = subscriber;
        });
        return observable;
    }

    observeSelection() {
        const observable = new Observable((subscriber) => {
            this.selectionSubscriber = subscriber;
        });
        return observable;
    }
}